import React from 'react';
import { Link } from 'gatsby';
import kebabCase from 'lodash.kebabcase'
import {
    Container, 
    Tag,
    TagContainer,
} from './styled';

import {
    Heading,
    Center,
} from '../../../pageStyles'


export const Tags = ({list}) => {

    return (
        <Container>
            <Center>
              <Heading>
                Tags
              </Heading>
            </Center>
            <TagContainer>
              {list.map(tag => 
                  <Link to={`/tags/${kebabCase(tag)}`}>
                    <Tag>
                        #{tag}
                    </Tag>
                  </Link>
                )}
            </TagContainer>
          </Container>
    );
}

